<template>
  <card>
    <DeleteConfirmation
      :currentDeleteMethod="deleteAvodConfg"
      ref="confirmDeleteAvod"
      @delete="$event()"
    />
    <DeleteConfirmation
      :currentDeleteMethod="deleteConfigData"
      ref="confirmDeletConfigData"
      @delete="$event()"
    />

    <b-modal
      id="newPlatformModal"
      ref="modal"
      @ok="saveAvodProvider"
      @cancel="exitDialog"
      @hide="exitDialog"
      :title="getDialogTitle()"
      ok-title="Save"
    >
      <form>
        <div>
          <span class="labelText">Slug</span>
          <input
            class="col-md-6 form-control "
            label="Slug"
            placeholder="Slug"
            v-model="curData.title"
            type="text"
          />
        </div>
        <div class="row">
          <fg-input class="col-md-12" label="Description">
            <textarea
              class="form-control"
              placeholder="Here can be your nice text"
              v-model="curData.description"
              rows="3"
            ></textarea>
          </fg-input>
        </div>
        <div class="row">
          <fg-input
            class="col-md-5"
            label="Config Name"
            placeholder="Config Name"
            v-model="currentConfigData.key"
          ></fg-input>

          <fg-input
            class="col-md-5"
            label="Config Parameter"
            placeholder="Config Parameter"
            v-model="currentConfigData.value"
          ></fg-input>

          <div class="col-md-2 addBtn">
            <button class="btn btn-primary" @click.prevent="addConfigData()">
              Add
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <el-table
              class="table-bigboy"
              style="width: 100%;"
              :data="configData"
              border
            >
              <el-table-column min-width="120" label="Key">
                <template slot-scope="{ row }">
                  {{ row.key }}
                </template>
              </el-table-column>
              <el-table-column min-width="140" label="Value">
                <template slot-scope="{ row }">
                  {{ row.value }}
                </template>
              </el-table-column>
              <el-table-column min-width="100" label="Action">
                <template slot-scope="props">
                  <a
                    v-tooltip.top-center="'Edit'"
                    class="btn-warning btn-simple btn-link"
                    @click="handleEditConfigData(props.$index, props.row)"
                    ><i class="fa fa-edit"></i
                  ></a>
                  <a
                    v-tooltip.top-center="'Delete'"
                    class="btn-danger btn-simple btn-link"
                    @click.prevent="handleDeleteConfigData(props.$index)"
                    ><i class="fa fa-trash"></i
                  ></a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal
      id="configdatas"
      ref="modal"
      title="Edit Config Data"
      @ok="checkConfigDataValue"
      ok-title="Save"
    >
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-4">
            <fg-input label="Key" v-model="editConfigData.key"></fg-input>
          </div>
          <div class="col-sm-4">
            <fg-input label="Value" v-model="editConfigData.value"></fg-input>
          </div>
        </div>
      </div>
    </b-modal>
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center py-3">
          <div>
            <span class="titleCard mb-2">
              AVOD
            </span>
          </div>
          <div
            class="d-flex justify-content-end align-items-center  searchContainer"
          >
            <div>
              <el-input
                type="text"
                style="width: 200px; "
                placeholder="Search records"
                ref="searchKey"
                prefix-icon="el-icon-search"
                v-model="searchQuery"
                aria-controls="datatables"
                clearable
              />
            </div>
            <div>
              <span class="demo-input-label ml-2 perPage"
                >Results per page:</span
              >
              <el-select
                class="select-default ml-1"
                v-model="pagination.perPage"
                style="width: 80px; "
                placeholder="Per page"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>

            <div class="mx-2 mt-1">
              <el-button
                type="primary"
                icon="el-icon-plus"
                v-b-modal.newPlatformModal
                @click="addVideoHost"
                >Add Avod
              </el-button>
            </div>
          </div>
        </div>
        <card>
          <div class="col-sm-12">
            <el-table stripe style="width: 100%;" :data="queriedData" border>
              <!-- <el-table-column min-width="180" label="Title">
                <template slot-scope="props">{{
                  getCName(props.row, "label")
                }}</template>
              </el-table-column>
              <el-table-column min-width="180" label="Description">
                <template slot-scope="props">{{
                  getCName(props.row, "description")
                }}</template>
              </el-table-column> -->
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column :min-width="120" fixed="right" label="Actions">
                <template slot-scope="props">
                  <a
                    v-tooltip.top-center="'Edit'"
                    class="btn-warning btn-simple btn-link"
                    v-b-modal.newPlatformModal
                    @click="handleEdit(props.$index, props.row)"
                    ><i class="fa fa-edit"></i
                  ></a>
                  <a
                    v-tooltip.top-center="'Delete'"
                    class="btn-danger btn-simple btn-link"
                    @click="handleDelete(props.$index, props.row)"
                    ><i class="fa fa-trash"></i
                  ></a>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            >
            </l-pagination>
          </div>
        </card>
      </div>
    </div>
  </card>
</template>

<script>
import { FormGroupInput as FgInput } from "src/components";
import { Table, TableColumn, Select, Option, Button } from "element-ui";
import { Pagination as LPagination } from "src/components/index";
import Fuse from "fuse.js";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import DeleteConfirmation from "src/pages/Dashboard/Components/DeleteConfirmation.vue";
import Vue from "vue";
export default {
  components: {
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    LPagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    DeleteConfirmation
  },
  computed: {
    queriedData() {
      let result = this.tableData;
      if (this.searchQuery !== "") {
        result = new Fuse(this.tableData, { keys: ["title"] }).search(
          this.searchQuery
        );
      }
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    }
  },
  data() {
    return {
      tableData: [],
      providerArray: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      dMode: "",
      searchQuery: "",
      configData: [],
      currentConfigData: {
        key: "",
        value: ""
      },
      editConfigData: {
        key: "",
        value: ""
      },
      editConfigDataIndex: "",
      deleteConfigDataIndex: "",
      curData: {
        customerId: "5bc27b3ffd1262442ee05391",
        title: "",
        description: "",
        configObj: {}
      },

      tableColumns: [
        // {
        //   prop: "configObj.url",
        //   label: "Url",
        //   minWidth: 150
        // },
        // {
        //   prop: "configObj.apiKey",
        //   label: "Api Key",
        //   minWidth: 250
        // },
        {
          prop: "title",
          label: "Title",
          minWidth: 250
        },
        {
          prop: "description",
          label: "Description",
          minWidth: 250
        }
      ]
    };
  },
  created() {
    this.$store
      .dispatch("getAvodProviderList")
      .then(response => {
        if (response) {
          for (var i = 0; i < response.data.length; i++) {
            var vh = {};
            vh.label = response.data[i].name;
            vh.value = response.data[i].id;
            vh.description = response.data[i].description;
            this.providerArray.push(vh);
          }
          // if (Array.isArray(response)) {
          //   this.curData.providerId = response.data[0].id;
          // }
        }
      })
      .catch(() => {});
    this.$store
      .dispatch("getAvodConfigList")
      .then(response => {
        this.tableData = response.data;
      })
      .catch(() => {});
  },
  methods: {
    getDialogTitle() {
      if (this.dMode == "create") {
        return "Create Avod";
      } else if (this.dMode == "edit") {
        return "Edit Avod";
      }
      return "";
    },
    deleteAvodConfg() {
      if (this.dMode == "delete" && this.deleteId) {
        this.$store
          .dispatch("deleteAvodConfig", this.deleteId)
          .then(response => {
            this.tableData.splice(this.deleteIndex, 1);
          })
          .catch(() => {});
      }
    },
    exitDialog() {
      this.dMode = "";
      this.curData = {
        title: "",
        description: "",
        configObj: {}
      };
    },
    saveAvodProvider() {
      this.curData.configObj = {};
      for (var i = 0; i < this.configData.length; i++) {
        this.curData.configObj[this.configData[i].key] = this.configData[
          i
        ].value;
      }
      if (this.dMode == "create") {
        this.$store
          .dispatch("createAvodConfig", this.curData)
          .then(response => {
            this.tableData.splice(0, 0, response.data.avodProviderConfig);
            this.$notify({
              title: "Success",
              message: "Avod Created Successfully!",
              type: "success"
            });
          })
          .catch(() => {
            this.$notify({
              title: "Error",
              message: "Failed To Create Avod !",
              type: "warning"
            });
          });
      } else if (this.dMode == "edit" && this.curData.id) {
        this.curData.configObj.title = this.curData.title;
        this.curData.configObj.description = this.curData.description;
        var req = {};
        req = this.curData;
        req.id = this.curData.id;
        this.$store
          .dispatch("updateAvodConfig", req)
          .then(response => {
            this.tableData.splice(this.curIndex, 1);
            this.tableData.splice(this.curIndex, 0, response);
            this.$notify({
              title: "Success",
              message: "Avod Updated Successfully!",
              type: "success"
            });
          })
          .catch(() => {
            this.$notify({
              title: "Error",
              message: "Update Video Host Failed!",
              type: "warning"
            });
          });
      }
      this.dMode = "";
      this.curData = {
        title: "",
        description: "",
        configObj: {}
      };
      this.configData = [];
    },
    handleEdit(index, row) {
      this.dMode = "edit";
      var pageNumbs =
        (this.pagination.currentPage - 1) * this.pagination.perPage;
      this.currentConfigData = {
        key: "",
        value: ""
      };
      this.configData = [];
      this.curData = JSON.parse(JSON.stringify(row));
      if (this.curData.configObj) {
        for (var key in this.curData.configObj) {
          var item = {};
          item.key = key;
          item.value = this.curData.configObj[key];
          this.configData.push(item);
          if (key === "title") {
            this.curData.title = this.curData.configObj[key];
            this.configData.pop();
          }
          if (key === "description") {
            this.curData.description = this.curData.configObj[key];
            this.configData.pop();
          }
        }
      }
      this.curIndex = pageNumbs + index;
    },
    handleDelete(index, row) {
      this.dMode = "delete";
      var pageNumbs =
        (this.pagination.currentPage - 1) * this.pagination.perPage;
      this.deleteId = row.id;
      this.deleteIndex = pageNumbs + index;
      this.$refs["confirmDeleteAvod"].$refs["deleteConfirmation"].show();
    },
    addVideoHost() {
      this.dMode = "create";
      this.currentConfigData = {
        key: "",
        value: ""
      };
      this.configData = [];
    },
    addConfigData() {
      if (
        this.currentConfigData.key == "" ||
        this.currentConfigData.value == ""
      ) {
        this.$notify({
          title: "Error",
          message: "ConfigData Fields are Invalid Format!",
          type: "warning"
        });

        return;
      }
      this.configData.push(JSON.parse(JSON.stringify(this.currentConfigData)));
      this.currentConfigData = {
        key: "",
        value: ""
      };
    },
    handleDeleteConfigData(index) {
      this.deleteConfigDataIndex = index;
      this.$refs["confirmDeletConfigData"].$refs["deleteConfirmation"].show();
    },
    deleteConfigData() {
      this.configData.splice(this.deleteConfigDataIndex, 1);
    },
    handleEditConfigData: function(index, row) {
      this.$refs.modal.show("#configdatas");
      this.editConfigData = JSON.parse(JSON.stringify(row));
      this.editConfigDataIndex = index;
    },
    checkConfigDataValue: function(index, row) {
      if (this.editConfigData.key == "" || this.editConfigData.value == "") {
        this.$notify({
          title: "Error",
          message: "ConfigData Fields are Invalid Format!",
          type: "warning"
        });

        return;
      }
      Vue.set(this.configData, this.editConfigDataIndex, this.editConfigData);
    },
    getCName(row, key) {
      var cid = row.providerId;
      if (this.providerArray && Array.isArray(this.providerArray)) {
        for (var i = 0; i < this.providerArray.length; i++) {
          if (this.providerArray[i].value == cid) {
            return this.providerArray[i][key];
          }
        }
      }
      return "";
    }
  },
  mounted() {
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["title", "description"]
    });
  }
};
</script>

<style scoped>
.perPage {
  font-weight: 400;
  font-size: 14px;
  color: #27282a;
  letter-spacing: 0.7px;
}

.titleCard {
  margin-left: 15px;
  font-weight: 400;
  font-size: 22px;
  color: #27282a;
  position: relative;
  right: 14px;
}
.searchContainer {
  position: relative;
  left: 7px;
}
.addBtn {
  margin-top: 28px;
}

.labelText {
  font-size: 12px;
  color: #9a9a9a;
  margin-bottom: 5px !important;
  font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
}
</style>
